import axios from '../../utils/axiosinstance'
// import axios from 'axios'
const state = {
  companies: [],
  company: [],
  allPlans: [],
  plainLoading: false,
  planImage: null
}
const getters = {
  companies: state => state.companies
}

const actions = {

  async updatePlan({ commit }, params){
    await axios.post(process.env.VUE_APP_BASE_AMF_URL+`&token=`+localStorage.sessiontoken, {
      "methodName": "updatePlan",
      "parameters": params,
      "serviceName": "ProjectdocuService"
    }, {
      headers: {
        apitoken: localStorage.apikey,
        deviceid: localStorage.deviceid,
        accept: 'application/json'
      }}).then(response => {
        if (response.statusText === 'OK' || response.status === 200){
          this._vm.$toast.success('Plan aktualisiert');
        }
    }).catch(e => {
      console.log(e)
    });
  },

  async getAllPlans({ commit }, id){
    await axios.post(process.env.VUE_APP_BASE_AMF_URL+`&token=`+localStorage.sessiontoken, {
      "methodName": "getPlansOfProject",
      "parameters": [id.toString()],
      "serviceName": "ProjectdocuService"
    }, {
      headers: {
        apitoken: localStorage.apikey,
        deviceid: localStorage.deviceid,
        accept: 'application/json'
      }}).then(response => {
      commit('setAllPlans',response.data.plans)
    }).catch(e => {
      console.log(e)
    });
  },


  async fetchCompanyInfo ({ commit }, params) {
    const response = await axios.post(
      'http://localhost/projects/aaa/hrsystem/public/api/company',
      params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
    )
    commit('fetchCompanyInfo', response.data.companies)
  },

  async addCompanyinfo ({ commit }, params) {
    const response = await axios
      .post(
        'http://localhost/projects/aaa/hrsystem/public/api/company/store',
        params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      )
      .then(response => {
        // self.$router.push('/company')
        // console.log(response)
        commit('addCompany', response.data.data)
      })
      .catch(response => {
        self.error_msg = response.data
        self.is_error = true
      })
  },

 async getPlanImageFile({commit},planId){
    const jwt = localStorage.getItem('jwt');
    await  fetch(`${process.env.VUE_APP_GET_METHOD_URL}img&id=${planId}&isplan=1&type=l&token=${jwt}`,
      {
        headers: {
          'Content-Type' : "application/json",
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid
        },
      }).then(response => response.blob())
      .then(response => {
        let reader = new FileReader()
        reader.readAsDataURL(response)
        reader.onload = function () {
          commit('setPlanImage',reader.result)
        }
      })
  },
  async rotatePlanImage({ commit }, payload){
    const jwt = localStorage.getItem('jwt');
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${jwt}`, {
      "methodName": "rotatePlan",
      "parameters": payload,
      "serviceName": "ProjectdocuService"
    }, {
      headers: {
        apitoken: localStorage.apikey,
        deviceid: localStorage.deviceid,
        accept: 'application/json'
      }}).then(response => {
         //image rotated successfully
      });

  },
  async deletePlanImage({ commit }, id){
    const jwt = localStorage.getItem('jwt');
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${jwt}`, {
      "methodName": "deletePlan",
      "parameters": [id],
      "serviceName": "ProjectdocuService"
    }, {
      headers: {
        apitoken: localStorage.apikey,
        deviceid: localStorage.deviceid,
        accept: 'application/json'
      }}).then(res => {
      this._vm.$toast.success('Plan gelöscht')
    }).catch(error => {
      this._vm.$toast.error(error)
    });
  },

}
const mutations = {
  addCompany: (state, company) => {
    state.company = company
  },
  togglePlainLoading(state,val){
    state.plainLoading = val
  },
  fetchCompanyInfo: (state, company) => {
    state.companies = company
  },

  setAllPlans: (state, payload) => ( state.allPlans = payload ),
  setPlanImage: (state, payload) => ( state.planImage = payload )

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/plans.js